export default "__VITE_ASSET__DpmP46hO__"